import Page from '@/features/Services/pages/Recruitment'

export default Page
